// Package Imports
import { RouterProvider } from '@tanstack/react-router'
import ReactDOM from 'react-dom/client'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

// Core Imports
import { router } from '@/core/routes'

// Shared Imports
import { ErrorBoundary } from '@/core/components/error-boundary'

// Style Imports
import '@/index.css'

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

dayjs.extend(customParseFormat)

const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <ErrorBoundary scope="root">
      <RouterProvider router={router} />
    </ErrorBoundary>
  )
}
